import { Controller } from "@hotwired/stimulus"

/**
 * Drives the Client Satisfaction email landing page.
 *
 * On connect (auto=true) it POSTs the grade the client picked in the email, so
 * the response is recorded by client-side script execution rather than the raw
 * GET — email-scanner pre-fetches of the link therefore never count as a
 * response. The server returns the confirmation fragment, which replaces the
 * container. That fragment includes an optional comment form (for every grade)
 * whose submit PATCHes back through the same controller.
 *
 * <div data-controller="client-satisfaction-response"
 *      data-client-satisfaction-response-url-value="/satisfaction/<token>"
 *      data-client-satisfaction-response-grade-value="unhappy"
 *      data-client-satisfaction-response-auto-value="true"></div>
 */
export default class extends Controller {
  static targets = ["comment"]
  static values = {
    url: String,
    grade: String,
    auto: { type: Boolean, default: false },
  }

  connect() {
    if (this.autoValue && this.gradeValue) {
      this.submit("POST")
    }
  }

  submitComment(event) {
    event.preventDefault()
    const comment = this.hasCommentTarget ? this.commentTarget.value : null
    this.submit("PATCH", comment)
  }

  async submit(method, comment = null) {
    const body = { response: this.gradeValue }
    if (comment !== null) body.comment = comment

    try {
      const response = await fetch(this.urlValue, {
        method,
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Accept: "text/html",
        },
        body: JSON.stringify(body),
      })
      this.element.innerHTML = await response.text()
    } catch (error) {
      this.element.innerHTML =
        "<p>Something went wrong recording your response. Please try again later.</p>"
    }
  }
}
